import React, { useState } from "react";
import { connect, useSelector } from "react-redux";
import LoaderButton from "../../../../shared/components/Button/LoaderButton";
import * as actions from '../../../../core/actions/actions';
import IState from "../../../../core/models/IState";
import { FormattedMessage } from "react-intl";

const Settings:React.FC<any> = (props) =>{     
    const language = useSelector((state: IState) => { return state.preferences.language })
    const [lang,setLang] = useState<string>(language)
    const submitHandler = () =>{
        props.changeLanguage(lang);
        props.modalClosed();
    }
    return (
        <div> 
             <div className="modal-body">
                <div className="row" >
                    <div className={"col-md-4"}>
                    <FormattedMessage id='Language' /> : 
                    </div>
                <div className={"col-md-4"}>
                    <input className="form-check-input" type="radio" name="language" id="language1" checked={ lang ==='en'&& true }
                    value='en' onChange={() => setLang('en')}/>
                    <label className="form-check-label" htmlFor="language1" >
                        English
                    </label>
                </div>            
                <div className={"col-md-4"}>
                    <input className="form-check-input " type="radio" name="language" id="language2" value='jp' checked={ lang ==='jp'&& true }
                    onChange={() => setLang('jp')}/>
                    <label className="form-check-label" htmlFor="language2">
                    日本語
                    </label>
                    </div>
                </div>
             </div>
            <div className = "modal-footer">
                <LoaderButton type="submit" text="Button_Save" onClick={submitHandler} />
            </div>
        </div>
    )
}
const mapStateToProps = () => ({

});

const mapDispatchToProps = (dispatch: any) => {
    return {
        changeLanguage: (lang: string) => dispatch(actions.changeLanguage(lang)),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(Settings);